import $ from 'jquery';
import 'slick-carousel';

function gamesSlider(
    key: string,
    gamesPerRow: number,
    autoplay: boolean,
    autoplaySpeed: number,
    centerMode: boolean
): void {
    $(`.gamesSlider-${key}`).slick({
        infinite: true,
        autoplay,
        autoplaySpeed,
        slidesToShow: gamesPerRow,
        slidesToScroll: gamesPerRow,
        prevArrow:
            "<button type='button' class='arrow-prev pull-left mr-2 arrow-style'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
        nextArrow:
            "<button type='button' class='arrow-next pull-right arrow-style'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
        appendArrows: $(`.arrows-${key}`),
        touchThreshold: 1000,
        centerMode,
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: 1050,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: false,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                    centerMode: false,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    centerMode: false,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                },
            },
        ],
    });
}

document.querySelectorAll<HTMLElement>('.gamesSlider').forEach((item) => {
    const count = item.getElementsByClassName('miniature game-miniature').length;
    const gamesPerRow = parseInt(item.getAttribute('data-gameSlider-games-per-row')) || 0;

    gamesSlider(
        item.getAttribute('data-gameSlider-key') || '',
        gamesPerRow,
        item.getAttribute('data-gameSlider-autoplay') === '1',
        parseInt(item.getAttribute('data-gameSlider-autoplay-speed')) || 6000,
        count > gamesPerRow
    );
});
